// A first-party hook for a consent-aware analytics integration. No SDK or data is
// transmitted here. Count clicks separately from installs in Play Console.
export function trackDownload() {
  const detail = {event: 'app_download_click', platform: 'android', page_path: window.location.pathname};
  window.dispatchEvent(new CustomEvent('hisabkitab:analytics', {detail}));
}
